import React, { FC } from 'react'

import { UniNotice } from 'api/uninotice/UniNotice'
import {
  UniNoticePayload,
  UniNoticeSecondaryHandler,
} from 'api/uninotice/uninotice.types'
import { noticePath } from 'common/constants'
import { VoidHandler } from 'common/types'
import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'

export const CommonNoticeViewNext: FC<{
  notice: UniNotice
  onActionClick: VoidHandler
  onSecondaryClick?: UniNoticeSecondaryHandler
}> = ({ notice: { payload }, onActionClick, onSecondaryClick }) => {
  const { text, noticeTitle, actionBtn, auxBtn, appearance, auxText } =
    payload as UniNoticePayload
  const imageUrl = payload?.image?.svgUrl
  const blocking = appearance?.blocking

  /**
   * Некоторые нотисы принимаюб id другого нотиса в качестве параметра
   * В таком случае, вторая кнопка должна переходить на страницу этого нотиса
   */
  const secondaryButtonActionProp = auxBtn?.action.data?.noticeId
    ? {
        secondaryButtonTo: `${noticePath}/${auxBtn?.action.data?.noticeId}`,
      }
    : {
        onSecondaryButtonClick: onSecondaryClick,
      }

  return (
    <MainLayout
      backButtonVisible={!blocking}
      logOutButtonVisible={blocking}
      icon={imageUrl ? <img src={imageUrl} width="200" height="200" /> : null}
      title={noticeTitle}
      description={text}
      primaryButtonText={actionBtn?.title}
      primaryButtonDataName={actionBtn?.action.actionId}
      secondaryButtonText={auxBtn?.title}
      secondaryButtonDataName={auxBtn?.action.actionId}
      onPrimaryButtonClick={onActionClick}
      {...secondaryButtonActionProp}
      annotation={auxText}
    />
  )
}
